import React from "react";
import { Avatar, Typography } from "antd";
import "./Profile.css";
import pfp from "../images/135225-0183.jpg";

const { Title, Paragraph } = Typography;

function Profile() {
  return (
    <div className="profile">
      <div className="profile-header">
        <Avatar size={125} src={pfp} className="profile-avatar" />
        <div className="profile-info">
          <Paragraph id="greeting">Hi! My name is</Paragraph>
          <Title level={2} id="name">LeAnn Tai</Title>
          <Paragraph id="short-bio">
            Computer science and engineering student, software developer, and designer.
          </Paragraph>
        </div>
      </div>
    </div>
  );
}

export default Profile;